import { Navigate, useSearchParams, type NavigateProps } from 'react-router-dom';

type Props = Omit<NavigateProps, 'to'> & {
  to: string;
};

/**
 * A Navigate component that preserves search params during redirect.
 * Use this instead of Navigate when you want to keep query parameters like platform_id.
 */
export const NavigateWithParams = ({ to, ...props }: Props) => {
  const [searchParams] = useSearchParams();
  const searchString = searchParams.toString();

  const destination = searchString ? `${to}?${searchString}` : to;

  return <Navigate to={destination} {...props} />;
};
